<template>
  <div class="section-speak">
    <div class="section-desktop is-hidden-touch">
      <div class="rs-main flex v-pb-lg">
        <div class="rs-interact-wrapper rs-interact-usermsgs">
          <div class="rs-panel">
            <div class="rs-panel-header no-border">
              <span class="rs-panel-header-icon"><a-icon type="caret-right" /></span>
              <div class="rs-panel-header-title">我要提问</div>
            </div>
            <div class="rs-panel-body rs-speak-body" v-if="roadshow.rsState === 0">
              <div class="msg-form">
                <div class="msg-form-control flex items-center v-mb-md relative-position" ref="userSpContainer">
                  <a-textarea v-model="userSpeakForm.spContent" ref="userSpContent" placeholder="" :auto-size="{ minRows: 8, maxRows: 8 }" />
                  <div class="gologin-tips">
                    <div class="text-grey"><a-icon type="warning" class="v-mr-xs" />路演已结束</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="rs-panel-body rs-speak-body" v-else-if="roadshow.rsType === 0">
              <div class="msg-form">
                <div class="msg-form-control flex items-center v-mb-md relative-position" ref="userSpContainer">
                  <a-textarea v-model="userSpeakForm.spContent" ref="userSpContent" placeholder="" :auto-size="{ minRows: 8, maxRows: 8 }" />
                  <div class="gologin-tips">
                    <div><a-icon type="warning" class="v-mr-xs text-grey" />向嘉宾提问，请先<span class="span-login" @click="openLoginModal(2)">登录</span></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="rs-panel-body rs-speak-body" v-else>
              <div class="flex items-center ls-1 font-sm" v-if="!userinfo.id">
                <span class=""
                  ><b>{{ userSpeakerName }}</b
                  >，您好！</span
                >
                <span class="span-login" style="margin-left: 10px" @click="openLoginModal(2)">登录</span>
              </div>
              <div class="rs-login-info" style="width: 280px; margin-bottom: 0" v-else-if="userinfo.type === 3">
                <span class="col"
                  >欢迎用户<b class="v-ml-xs">{{ userinfo.realName || userinfo.userName }}</b></span
                >
                <button class="rs-button mini button-primary" @click="logout">退出</button>
              </div>
              <div class="msg-form">
                <div class="flex items-center">
                  <div class="msg-form-control flex items-center v-mt-md font-sm v-mr-md" v-if="!userinfo.id">
                    <a-input v-model="userSpeakForm.spSpeakerName" style="width: 200px" placeholder="输入您的昵称" />
                  </div>
                  <div class="msg-form-control flex items-center v-mt-md font-sm">
                    <span class="v-mr-md">向</span>
                    <a-select
                      class="rs-select"
                      :class="[`rs-select-${roadshow.styleType}`]"
                      :dropdown-class-name="`rs-select-dropdown rs-select-dropdown-${roadshow.styleType}`"
                      v-model="userSpeakForm.spGuestId"
                      placeholder="选择提问嘉宾"
                      style="width: 200px; margin-right: 12px"
                    >
                      <a-select-option :key="item.gId" :value="item.gId" v-for="item in guests" :title="`${item.gName}${item.gPost ? '（' + item.gPost + '）' : ''}`">
                        <b>{{ item.gName }}</b
                        ><template v-if="item.gPost">（{{ item.gPost }}）</template>
                      </a-select-option>
                    </a-select>
                    提问：
                  </div>
                </div>
                <div class="msg-form-control flex items-center v-mt-md relative-position" ref="userSpContainer">
                  <a-textarea v-model="userSpeakForm.spContent" ref="userSpContent" placeholder="" :auto-size="{ minRows: 8, maxRows: 8 }" />
                </div>
                <div class="v-mt-sm v-mb-md">
                  <div class="textarea-tips text-right" v-if="userSpeakFormContentLen <= 200">
                    还可输入<b>{{ 200 - userSpeakFormContentLen }}</b
                    >字
                  </div>
                  <div class="textarea-tips text-red text-right" v-else>
                    内容已超出<b>{{ userSpeakFormContentLen - 200 }}</b
                    >字
                  </div>
                </div>
                <div class="msg-form-actions">
                  <a-space :size="12">
                    <a-button type="primary" class="rs-button button-primary" :loading="userSpeakSaving" @click="handleSumbitUserSpeak">确认提交</a-button>
                    <button class="rs-button button-reset">重置</button>
                  </a-space>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-touch is-hidden-desktop">
      <template v-if="showSpeakButton">
        <!-- 封闭式路演登录 -->
        <div class="rs-button-bottom fixed shadow" @click="openLoginModalFromMsgPopup(2)" v-if="roadshow.rsType === 0 && !userinfo.id">
          <div class="flex items-center justify-center"><a-icon type="export" style="font-size: 20px" class="v-mr-sm" />我要登录</div>
        </div>
        <!-- 嘉宾发言 -->
        <div class="rs-button-bottom fixed shadow" @click="openSpeakModal" v-else-if="userinfo.type === 0 && roadshow.rsState === 1">
          <div class="flex items-center justify-center"><img src="~@/assets/images/icon_msg.png" width="20" class="v-mr-sm" />我要发言</div>
        </div>
        <!-- 游客/会员提问 -->
        <div class="rs-button-bottom fixed shadow" @click="openMsgPopup" v-else-if="(!userinfo.id || userinfo.type === 3) && roadshow.rsState === 1">
          <div class="flex items-center justify-center"><img src="~@/assets/images/icon_msg.png" width="20" class="v-mr-sm" />我要提问</div>
        </div>
      </template>
      <van-popup v-model="msgPopup" position="bottom" closeable>
        <div class="rs-button-bottom">
          <div class="flex items-center justify-center"><img src="~@/assets/images/icon_msg.png" width="20" class="v-mr-sm" />我要提问</div>
        </div>
        <div class="msg-popup-contaner">
          <div class="flex items-center ls-1 font-sm" v-if="!userinfo.id">
            <span class=""
              ><b>{{ userSpeakerName }}</b
              >，您好！</span
            >
            <span class="span-login" @click="openLoginModalFromMsgPopup(2)">登录</span>
          </div>
          <div class="flex items-center ls-1 font-sm" v-else-if="userinfo.type === 3">
            <span class=""
              ><b>{{ userinfo.realName || userinfo.userName }}</b
              >，您好！</span
            >
            <span class="span-login" @click="logoutModalFromMsgPopup()">登出</span>
          </div>
          <div class="msg-form-control flex items-center v-mt-sm" v-if="!userinfo.id">
            <a-input v-model="userSpeakForm.spSpeakerName" style="width: 200px; margin-right: 12px" placeholder="输入您的昵称" /> 向
          </div>

          <div class="msg-form-control flex items-center v-my-md">
            <div class="rs-select ant-select ant-select-enabled rs-select-blue" style="width: 200px; margin-right: 12px" @click="showGuestPicker = true">
              <div role="combobox" class="ant-select-selection ant-select-selection--single">
                <div class="ant-select-selection__rendered">
                  <div unselectable="on" class="ant-select-selection__placeholder" style="display: block; user-select: none">
                    <span class="text-grey-7" v-if="userSpeakForm.spGuestId">{{ userSpeakForm.spGuest }}{{ userSpeakForm.spGuestPost ? '（' + userSpeakForm.spGuestPost + '）' : '' }}</span>
                    <span v-else>选择提问嘉宾</span>
                  </div>
                </div>
                <span unselectable="on" class="ant-select-arrow" style="user-select: none"><a-icon type="down" /></span>
              </div>
            </div>
            <span v-if="!userinfo.id">提问：</span>
          </div>
          <div class="msg-form-control v-my-md">
            <a-textarea placeholder="提问内容" v-model="userSpeakForm.spContent" :auto-size="{ minRows: 8, maxRows: 8 }" />
            <div class="textarea-tips" v-if="userSpeakFormContentLen <= 200">
              还可输入<b>{{ 200 - userSpeakFormContentLen }}</b
              >字
            </div>
            <div class="textarea-tips text-red" v-else>
              内容已超出<b>{{ userSpeakFormContentLen - 200 }}</b
              >字
            </div>
          </div>
          <div class="msg-form-actions">
            <a-space :size="12">
              <a-button type="primary" class="rs-button button-primary" :loading="userSpeakSaving" @click="handleSumbitUserSpeak2">确认提交</a-button>
              <button class="rs-button button-reset" @click="userSpeakForm.spContent = ''">重置</button>
            </a-space>
          </div>
        </div>
      </van-popup>
      <van-popup v-model="showGuestPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="guests.map((item) => ({ text: `${item.gName}${item.gPost ? '（' + item.gPost + '）' : ''}`, ...item }))"
          @cancel="showGuestPicker = false"
          @confirm="onGuestPickerConfirm"
        />
      </van-popup>
    </div>
  </div>
</template>

<script>
import { saveUserSpeak } from '@/api/interact'
export default {
  name: 'RoadshowSpeak',
  data() {
    return {
      rsId: this.$route.query.id,
      userSpeakerName: `游客${Math.random().toString().substring(2, 8)}`,
      userSpeakForm: {
        spGuestId: undefined,
        spGuest: '',
        spSpeakerName: '',
        spContent: '',
        spGuestPost: '',
      },
      userSpeakSaving: false,
      showSpeakButton: true,
      msgPopup: false,
      showGuestPicker: false,
    }
  },
  computed: {
    userinfo: (vm) => vm.$store.state.user.userinfo,
    guests: (vm) => vm.$store.state.app.guests,
    roadshow: (vm) => vm.$store.state.app.roadshow,
    userSpeakFormContentLen: (vm) => vm.userSpeakForm.spContent.trim().length,
  },
  methods: {
    openLoginModal(type) {
      this.$root.$emit('openLoginModal', type)
      // this.$root.$emit('statVisit', 2)
    },
    handleSumbitUserSpeak() {
      let vm = this
      let { spGuestId, spSpeakerName, spContent, spGuest } = this.userSpeakForm
      // this.$message.destroy()
      if (spContent.trim() === '') {
        // this.$message.warning('请输入提问内容')
        this.$toast({
          message: '请输入提问内容',
          position: 'bottom',
          getContainer: () => this.$refs.userSpContainer,
        })
        this.$refs.userSpContent.focus()
        return
      }
      if (this.userSpeakFormContentLen > 200) {
        this.$toast({
          message: '提问内容字数太多啦',
          position: 'bottom',
        })
        return
      }
      if (spGuestId) {
        let guest = this.guests.find((g) => g.gId === spGuestId)
        spGuest = guest ? guest.gName : ''
      }
      if (spSpeakerName.trim() === '') {
        spSpeakerName = this.userSpeakerName
      }
      let params = {
        spGuest,
        spGuestId,
        spSpeakerName,
        spContent,
        rsId: this.rsId,
      }
      let { id, userName, realName } = this.userinfo
      if (id) {
        params.spSpeakerId = id
        params.spSpeakerName = realName || userName
      }
      this.userSpeakSaving = true
      saveUserSpeak(params)
        .then(({ data }) => {
          if (data.success) {
            this.$toast.success('提交成功')
            this.userSpeakForm.spContent = ''
            setTimeout(() => {
              let { pageNum, pageSize } = vm.unrepliedPg
              vm.loadUnreplied(pageNum, pageSize)
            }, 1000)
          } else {
            this.$toast.fail(data.msg || '提交失败，请重试')
          }
          this.userSpeakSaving = false
        })
        .catch(() => {
          this.$message.warning('提交失败，请重试')
          this.userSpeakSaving = false
        })
      this.$root.$emit('statVisit', 2)
    },
    handleSumbitUserSpeak2() {
      let vm = this
      let { spGuestId, spSpeakerName, spContent, spGuest } = this.userSpeakForm
      this.$message.destroy()
      if (spContent.trim() === '') {
        this.$toast({
          message: '请输入提问内容',
          position: 'bottom',
        })
        return
      }
      if (this.userSpeakFormContentLen > 200) {
        this.$toast({
          message: '提问内容字数太多啦',
          position: 'bottom',
        })
        return
      }
      if (spGuestId) {
        let guest = this.guests.find((g) => g.gId === spGuestId)
        spGuest = guest ? guest.gName : ''
      }
      if (spSpeakerName.trim() === '') {
        spSpeakerName = this.userSpeakerName
      }
      let params = {
        spGuest,
        spGuestId,
        spSpeakerName,
        spContent,
        rsId: this.rsId,
      }
      let { id, userName, realName } = this.userinfo
      if (id) {
        params.spSpeakerId = id
        params.spSpeakerName = realName || userName
      }
      this.userSpeakSaving = true
      saveUserSpeak(params)
        .then(({ data }) => {
          if (data.success) {
            this.$toast.success('提交成功')
            this.msgPopup = false
            setTimeout(() => {
              let { pageNum, pageSize } = vm.unrepliedPg
              vm.loadUnreplied(pageNum, pageSize)
            }, 1000)
          } else {
            this.$toast({
              message: data.msg,
              position: 'bottom',
            })
          }
          this.userSpeakSaving = false
        })
        .catch(() => {
          this.$toast({
            message: '提交失败，请重试',
            position: 'bottom',
          })
          this.userSpeakSaving = false
        })
      this.$root.$emit('statVisit', 2)
    },
    logout() {
      this.$store.dispatch('logout')
    },
    setSpeakButton(status = false) {
      this.showSpeakButton = status
    },
    openLoginModalFromMsgPopup(type) {
      this.msgPopup = false
      this.openLoginModal(type)
      // this.$root.$emit('statVisit', 2)
    },
    openMsgPopup() {
      this.userSpeakForm.spGuestId = undefined
      this.userSpeakForm.spGuest = ''
      this.userSpeakForm.spGuestPost = ''
      this.userSpeakForm.spContent = ''
      this.msgPopup = true
      this.$root.$emit('statVisit', 2)
    },
    onGuestPickerConfirm(item) {
      this.userSpeakForm.spGuestId = item.gId
      this.userSpeakForm.spGuest = item.gName
      this.userSpeakForm.spGuestPost = item.gPost
      this.showGuestPicker = false
    },
    logoutModalFromMsgPopup() {
      this.$store.dispatch('logout')
      this.$root.$emit('statVisit', 2)
    },
    openSpeakModal() {},
  },
  created() {
    this.$root.$on('setSpeakButton2', this.setSpeakButton)
  },
}
</script>
